import {twMerge} from '../../../common/twMerge';
import {InternalStaticImageType} from '../../atoms/StaticImage/InternalStaticImageType.enum';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {ErrorAreaChildProps} from './ErrorAreaChildProps.interface';

export function ErrorAreaImage({
  type = StaticImageType.ModalCashStatic,
  size = 70,
  className,
  ...props
}: ErrorAreaChildProps & {
  type?: StaticImageType | InternalStaticImageType;
  size?: number;
}) {
  return (
    <div className={twMerge('inline-flex', className)} {...props}>
      <StaticImage
        imageType={type}
        style={
          size
            ? {
                height: size,
                width: size,
              }
            : undefined
        }
      />
    </div>
  );
}

export const ErrorAreaImageType = (<ErrorAreaImage />).type;
